import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCamera(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.27 4.438a.25.25 0 0 0-.218.126l-.737 1.3a1.75 1.75 0 0 1-1.522.886H4.75c-.69 0-1.25.56-1.25 1.25v10.313c0 .69.56 1.25 1.25 1.25h14.5c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25h-2.043a1.75 1.75 0 0 1-1.522-.886l-.737-1.3a.25.25 0 0 0-.218-.127zm-1.522-.614a1.75 1.75 0 0 1 1.522-.886h5.46c.63 0 1.211.338 1.522.886l.738 1.3a.25.25 0 0 0 .217.126h2.043A2.75 2.75 0 0 1 22 8v10.313a2.75 2.75 0 0 1-2.75 2.75H4.75A2.75 2.75 0 0 1 2 18.313V8a2.75 2.75 0 0 1 2.75-2.75h2.043a.25.25 0 0 0 .217-.127z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 9.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5M7.25 13a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0",
    clipRule: "evenodd"
  }));
}
var IcCamera = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCamera));

export { IcCamera as I };
